module.exports = __webpack_public_path__ + "img/cross.a91043a5.svg";